// http状态  todo 待补充
const RESPONSE_OK = 200;
const RESPONSE_NO_AUTH = 401;

const httpMethod = {
	get: 'GET',
	post: 'POST',
	put: 'PUT',
	delete: 'DELETE',
};

export { RESPONSE_OK, RESPONSE_NO_AUTH, httpMethod };
